import APIDoc from "../api/api";
import Kichiri from "react-kichiri";
import ConfigurationService from "./ConfigurationService.js";

export default new Kichiri(APIDoc, ConfigurationService.resolveApi().rest, false).api;
